import React from 'react';
import PropTypes from 'prop-types';
import PopoverComponent from "../../../gd-components/base-component/popover-component";

import SelectPopover from './popover/popover-select';

const debug={
    dev: false,
    error: true,
    head: "[Form Select New]"
};

export default class FormSelect extends PopoverComponent {

    static props = {
        // actually we do not need it I think if you need it better use form !!!
        // statefull: PropTypes.bool,            // if TRUE - it has STATE (!) be mega carefull about it as it's probably the wrong approach here

        multiselect: PropTypes.bool,          // if yes -> checkboes... checkboxes...

        options: PropTypes.array.isRequired,  // yes options not items ... better name

        placeholder: PropTypes.string,
        disabled: PropTypes.bool,                        // do we need it ?

        // look and feel
        size: PropTypes.oneOf(['big','30','small']),   // big small 36 / 30

        // this is value (not clicked current value)
        renderValue: PropTypes.oneOf(['text', 'icon-text', 'func']).isRequired, // render value view name
        renderValueFunc: PropTypes.func,        // func for external render function if passwed used to render instead of default

        // this is for dropdown
        renderOption: PropTypes.oneOf(['text', 'icon-text', 'func']).isRequired, // render value view name
        renderOptionFunc: PropTypes.func,        // func for external render function if passwed used to render instead of default

        // Form
        form: PropTypes.object, //.isRequired,
        name: PropTypes.string, //.isRequired,

        // NOT Form
        value: PropTypes.any,   // if not form passed will be stateless componenet with selected value


        // advanced options
        searchable: PropTypes.bool,
        keyboardNavigation: PropTypes.bool,

        manageLabel: PropTypes.string,

        // Callbacks
        onUserSelect: PropTypes.func,            // similar to onChange but triggers only when user chages somethings
        // emptyRenderer: PropTypes.func,
        // optionRenderer: PropTypes.func,
        // valueRenderer: PropTypes.func,

        onManageOptions: PropTypes.func,

        onTogglePopover: PropTypes.func,
        popoverFitTargetWidth: PropTypes.bool,
        popoverStyle: PropTypes.object,
        popoverClass: PropTypes.string,         // yes we use it ... cusotm popover i.e. color icons in select skin color
        popoverContentClass: PropTypes.string,

        // Popover position
        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        targetOffset: PropTypes.string,
        scrollContentStyle: PropTypes.object,

        // iconSize: PropTypes.oneOf(['tiny', '22']),
        // iconPosition: PropTypes.oneOf(['left', 'right'])
    };

    static defaultProps = {
        // iconSize: 'tiny',
        // iconPosition: 'left',

        multiselect: false,

        placeholder: 'Please select',

        size: 'big',

        renderValue: 'text',
        renderOption: 'text',


        popoverFitTargetWidth: true,

        searchable: true,
        keyboardNavigation: true
    };

    constructor(props) {
        super(props);

        let curValue = null;
        if (this.props.multiselect) {
            curValue = [];
            if (this.props.form) {
                curValue = this.props.form.getValue(this.props.name);
                if (!curValue) curValue = [];
            }
        }


        this.state = {
            value: curValue // seems like this is used ONLY in multiselect hm...
        };

        this._bind('onChange');

        if (this.props.form) {
            this.props.form.registerFormComponent(this.props.name,this);
        }

    }

    UNSAFE_componentWillMount() {
        if (this.props.form) {
            this.props.form.registerFormComponent(this.props.name,this);
        }
    }

    // is it called by form manger ???
    triggerOnChange(changedValue) {

        // what is form field ? props ? we don't pass it ? no po hodu eto nado - ili eto form field dlya form-field Design Request form ????
        // yeah this is something epic old from form-mixin
        // if (this.props.form) this.props.form.onElementChange(this.props['form-field'],changedValue);

        // if (this.props.onChange) this.props.onChange(changedValue);
    }

    onChange(newValue) {
        if (debug.dev) console.log(debug.head, "onChange", newValue);

        if (this.props.multiselect) {

            if (this.state.value.includes(newValue)) {
                this.state.value.remove(newValue);
            } else {
                this.state.value.push(newValue);
            }

            newValue = this.state.value;

            this.setState({
                value: newValue //this.state.value
            });
        } else {
            this.hidePopover();
        }

        if (this.props.form) {
            this.props.form.onFormComponentValueChange(this.props.name,newValue);
        }

        if (this.props.onUserSelect) this.props.onUserSelect(newValue);
        if (this.props.onChange) this.props.onChange(newValue);
    }

    initCurrentValue() {

        // experimental
        if (this.props.multiselect) {
            return this.state.value;
            // if (!value) value = [];
        }


        let value;

        if (this.props.form) value = this.props.form.getValue(this.props.name);     // Form mode
        else value = this.props.value; // no form stand alone mode

        // check if VALUE is within options - if not reset value for rendering so we dont' have error
        let valueFound = (!value); // if value null value found = true
        if (value && this.props.options) this.props.options.map((option)=>{
            if (option.value === value) valueFound = true;
        });

        // if current value is not within options
        if (!valueFound) {
            if (debug.error) console.warn(debug.head,"value is not found within options. reset to null;");
            // here theoretically we can have error eith doubel render / set state... if we do options for select should be come form structure part ?

            value = null;

            //silent set field value to null with proper validation
            if (this.props.form) {
                this.props.form.setValue(this.props.name,null,{silent: true})
            }
        }

        return value;
    }

    onManageOptions = (e) => {
        this.hidePopover()
        this.props.onManageOptions(e)
    }

    renderValue(value) {
        let selectedOption = false;

        const onClick = !this.props.disabled?this.togglePopover:()=>{};

        if (this.props.multiselect) {

            const hasValue = (this.state.value.length>0);
            const curValueClasses = Classes('cur-value', 'pop-target', 'multiselect', {
                'no-value': !hasValue,
                'has-value': hasValue
            });

            return (
                <div className={curValueClasses} onClick={onClick}>
                    {hasValue && this.state.value.map((value,key)=>{

                        const option = _.find(this.props.options,{value: value});
                        if (!option) return false;

                        return (
                            <span className="item" key={key}>{option.label}</span>
                        )
                    })}
                    { !hasValue && <span className="name">{this.props.placeholder}</span> }
                    <div className="i5-big-angle-down"/>
                </div>
            )
        }


        if (this.props.options) {
            this.props.options.map(option=>{
                if (option.value === value) selectedOption = option;
            });
        }

        const label = (selectedOption)?selectedOption.label:this.props.placeholder;

        const curValueClasses = Classes('cur-value', 'pop-target', {
            'no-value': !selectedOption,
            'has-value': !!selectedOption
        });

        switch (this.props.renderValue) {

            case 'icon-text':
                return(
                    <div className={curValueClasses} onClick={onClick}>
                        {selectedOption.icon && <span className={Classes('icon', selectedOption.icon)}/> }
                        <span className="name">{label}</span>
                        <div className="i5-big-angle-down"/>
                    </div>
                );

            case 'text':
                return(
                    <div className={curValueClasses} onClick={onClick}>
                        <span className="name">{label}</span>
                        <div className="i5-big-angle-down"/>
                    </div>
                );

            case 'func':
                return (
                    <div className={curValueClasses} onClick={onClick}>
                        {this.props.renderValueFunc(selectedOption, value)}
                        <div className="i5-big-angle-down"/>
                    </div>
                );
        }
    }

    render() {
        const value = this.initCurrentValue();

        const classes = Classes('gd-form-select-new', 'size-'+this.props.size, this.props.className, {
            disabled: this.props.disabled
        });

        // potential needs
        // {onRemove && renderValue !== 'pills' &&
        // <div className="remove-option-icon i5-delete-circle-solid" onClick={this.onRemoveClick}> </div>}
        // {hint && !showPopover && <HintPopover parent={this} hint={hint}/>}

        return (
            <div className={classes}>
                {this.renderValue(value)}

                {this.state.showPopover &&
                <SelectPopover searchable={this.props.searchable}
                               options={this.props.options}
                               multiselect={this.props.multiselect}
                               currentValue={value}
                               hidePopover={this.hidePopover}
                               onOptionSelect={this.onChange}
                               showHelp={!!this.props.onManageOptions}
                               manageLabel={this.props.manageLabel}
                               onManageOptions={this.onManageOptions}
                               renderOption={this.props.renderOption}
                               renderOptionFunc={this.props.renderOptionFunc}
                               popoverClass={this.props.popoverClass}
                               popoverContentClass={this.props.popoverContentClass}
                               outsideClickIgnoreClass={this.props.outsideClickIgnoreClass}/>}
            </div>
        );
    }
}
